import { useState, useEffect } from 'react';
import Axios from '../utils/axiosInstance';

const useCities = () => {
  const [cities, setCities] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const response = await Axios.get(`${process.env.REACT_APP_API_BASE_URL}shipment/shipping-charges/`);
        setCities(response.data.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchCities();
  }, []);

  return { cities, loading, error };
};

export default useCities;
